import { Separator } from "@/components/ui/separator";

export default function ReturnPolicyPage({ settings }) {
  const name = settings?.business_name || "PennyMacs";
  return (
    <div data-testid="return-policy-page">
      <section className="hero-gradient py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1d1d1f] tracking-tight">
            Return Policy
          </h1>
          <p className="mt-3 text-sm text-[#86868b]">Last updated: February 2026</p>
        </div>
      </section>
      <section className="py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Return Window</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              If you are not satisfied with your purchase, you may request a return within 7 days of receiving your MacBook. The item must be in the same condition as when it was shipped.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">How to Initiate a Return</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Contact us via email or phone with your order details. We will provide return shipping instructions. Please do not ship items back without contacting us first.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Refund Process</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Once we receive and inspect the returned MacBook, we will process your refund within 5-7 business days. Refunds will be issued to the original payment method.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Non-Returnable Items</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Items that have been physically damaged after delivery, modified, or are missing components are not eligible for return. Warranty claims for hardware defects are handled separately.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Questions?</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              If you have any questions about returns, contact us at {settings?.email || "our email address"} or call {settings?.phone || "us"}.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
